import React from "react";
import ActivityLogTable from "../components/activity-log/ActivityLogTable";

const ActivityLogs = () => {
  return (
    <div>
      <ActivityLogTable />
    </div>
  );
};

export default ActivityLogs;
